import { defineComponent as _defineComponent } from 'vue'
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { SnowplowContext } from '@/helpers/tracking/providers';
import type { CatalogueItem } from '@/helpers/promotion-helper';

import GridRowLabel from '@/features/buybox/components/grid/GridRowLabel.vue';
import GridPromotionSwiper from '@/components/experiments/GridSwiperExp/components/GridPromotionSwiper.vue';
import { useGridSwiperExp } from '@/components/experiments/GridSwiperExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'GridSwiperExp',
  props: {
    title: null,
    providerShortName: null,
    catalogueItem: null,
    additionalContexts: null
  },
  setup(__props: any) {

const GridSQTV = () => import('@/features/buybox/components/grid/GridSQTV.vue');
const GridQTV = () => import('@/components/experiments/GridSwiperExp/GridQTV.vue');
const GridSwiperFreeTrial = () => import('@/components/experiments/GridSwiperExp/GridSwiperFreeTrial.vue');



const { promotionItems } = useGridSwiperExp();

return { __sfc: true,GridSQTV, GridQTV, GridSwiperFreeTrial, promotionItems, GridRowLabel, GridPromotionSwiper }
}

})